<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
             <b-col lg="12" class="my-1">
              <b-form-group
                label="Pesquisar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Nome do Item"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="table-itens" @filtered="onFiltered" :filter="filter" :filter-included-fields="filterOn" striped small :fields="fields" :items="itens" responsive="sm" :per-page="perPage" :current-page="currentPage">
                        
                        <template v-slot:cell(problema)="data">
                           <span>{{ data.item.problema ? data.item.problema.idProblema : '-' }}</span>
                        </template>

                        <template v-slot:cell(tipos)="data">
                           <b-badge v-for="t in getTiposArray(data.item.idItem)" :key="t" variant="info" style="margin-right: 2px;">{{ t }}</b-badge>
                        </template>




                        <template v-slot:cell(status)="data">
                           <toggle-button 
                              :value="data.item.status" 
                              @change="alterarStatus(data.item)" 
                              :sync="true" 
                              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"
                              :color="{checked: '#303f9f', unchecked: '#dc3545'}"
                              :width="70"
                           />
                        </template>

                        <template v-slot:cell(acoes)="data">
                            <b-button @click="visualizar(data.item)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px" title="Editar"><b-icon icon="pencil"></b-icon></b-button>
                            <!-- <b-button @click="confirmarDelecao(data.item)" class="v-button" size="sm" style="background-color: #dc3545;" title="Deletar"><b-icon icon="trash"></b-icon></b-button> -->
                        </template>

                      </b-table>
                      <div style="float: right">
                        <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="table-itens"
                        ></b-pagination>
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
              <b-card bg-variant="light">
                <div class="row" style="float: right">
                    <b-button v-b-modal.modal-item style="margin-right: 30px; background-color: #303f9f" @click="resetModal">
                      <b-icon icon="plus-circle"></b-icon> Novo Item
                    </b-button>   
                </div>
              </b-card>
        </b-col>
      </b-row>
      
      <!-- Modal Formulário Item -->
      <b-modal id="modal-item" ref="modal" :title="(item && item.idItem) ? 'Editar Item' : 'Novo Item'" @hidden="resetModal" @ok="salvar" ok-title="Salvar" cancel-title="Cancelar">
        <template v-if="item">
          <b-form-group label="Nome" label-for="nome-input">
              <b-form-input id="nome-input" v-model="item.nome" required placeholder="Ex: Ar-Condicionado"></b-form-input>
          </b-form-group>

          <b-form-group label="Descrição" label-for="descricao-input">
              <b-form-textarea id="descricao-input" v-model="item.descricao" rows="3" placeholder="Detalhes do item..."></b-form-textarea>
          </b-form-group>

          <b-form-group label="Problema Padrão" label-for="problema-input">
              <model-list-select :list="problemas"
                  v-model="item.problema.idProblema"
                  option-value="idProblema"
                  option-text="descricao"
                  placeholder="Selecione um Problema">
              </model-list-select>
          </b-form-group>
          
          <b-form-group label="Status" v-if="!item.idItem">
            <toggle-button 
                v-model="item.status" 
                :labels="{checked: 'Ativo', unchecked: 'Inativo'}"
                :color="{checked: '#303f9f', unchecked: '#dc3545'}"
                :width="70"
            />
          </b-form-group>

          <b-form-group label="Exibir em Checklists/Inventários de:" class="mt-3">
            <b-form-checkbox-group
              v-model="item.tiposSelecionados"
              :options="opcoesTipo"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </template>
      </b-modal> 
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import ItemService from '../../services/ItemService';
import { ModelListSelect } from 'vue-search-select';

export default {
  components: { BarraNavegacao, ModelListSelect },

  data(){
    return{
      itens: [],
      problemas: [],
      configuracoesGerais: [],
      item: {
          idItem: null,
          nome: '',
          descricao: '',
          status: true,
          problema: { idProblema: null },
          tiposSelecionados: ['ANDAR', 'CORREDOR', 'SALA']
      },
      opcoesTipo: [
        { text: 'Andar', value: 'ANDAR' },
        { text: 'Corredor', value: 'CORREDOR' },
        { text: 'Sala', value: 'SALA' }
      ],
      fields: [
        { key: 'idItem', label: 'ID', class:'text-center', sortable: true },
        { key: 'nome', label: 'Nome' , class:'text-center', sortable: true },
        { key: 'descricao', label: 'Descrição' , class:'text-center' },
        { key: 'problema', label: 'Problema' , class:'text-center' },
        { key: 'tipos', label: 'Locais' , class:'text-center' },
        { key: 'status', label: 'Status' , class:'text-center' },
        { key: 'acoes', label: 'Ações' , class:'text-center' }
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      filter: null,
      filterOn: ['nome'],
    }
  },

  created(){
    this.listarItens();
    this.listarProblemas();
    this.listarConfiguracoes();
  },

  methods: {
    listarConfiguracoes() {
        this.$http.get("/item-configuracao").then(res => {
            if (Array.isArray(res.data)) {
                this.configuracoesGerais = res.data;
            }
        });
    },

    getTiposArray(idItem) {
        return this.configuracoesGerais
            .filter(c => c.idItem === idItem)
            .map(c => c.tipo);
    },

    alertaMensager(mensagem, titulo, tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
          });
    },

    salvar(bvModalEvent){
        // Previne fechamento automático
        bvModalEvent.preventDefault();
        
        if (!this.item.nome) {
            this.alertaMensager("O nome do item é obrigatório.", "Atenção", "warning");
            return;
        }

        let payload = {
            nome: this.item.nome,
            descricao: this.item.descricao,
            problema: (this.item.problema && this.item.problema.idProblema) ? { idProblema: this.item.problema.idProblema } : null
        };
        // Para o cadastro também podemos enviar o status
        if (!this.item.idItem) {
            payload.status = this.item.status;
        }

        if (this.item.idItem) {
            // Atualizar
            ItemService.atualizar(this.item.idItem, payload).then((res) => {
                if (res.status === 203) {
                    this.alertaMensager(res.data, "Erro", "error");
                } else {
                    this.$http.post('/item-configuracao', { idItem: this.item.idItem, tipos: this.item.tiposSelecionados }).then(() => {
                        this.alertaMensager("Item atualizado com sucesso!", "", "success");   
                        this.listarItens();
                        this.listarConfiguracoes();
                        this.$refs.modal.hide();
                    }).catch(() => {
                        this.alertaMensager("Item salvo, mas falha na configuração de local.", "Erro", "error");
                    });
                }
            }).catch(() => {
                this.alertaMensager("Erro ao atualizar item no servidor.", "Erro", "error");
            });
        } else {
            // Cadastrar
            ItemService.cadastrar(payload).then((res) => {
                if (res.status === 203) {
                    this.alertaMensager(res.data, "Erro", "error");
                } else {
                    let newIdItem = res.data.idItem || res.data;
                    this.$http.post('/item-configuracao', { idItem: newIdItem, tipos: this.item.tiposSelecionados }).then(() => {
                        this.alertaMensager("Item cadastrado com sucesso!", "", "success");   
                        this.listarItens();
                        this.listarConfiguracoes();
                        this.$refs.modal.hide();
                    }).catch(() => {
                        this.alertaMensager("Item salvo, mas falha na configuração de local.", "Erro", "error");
                    });
                }
            }).catch(() => {
                this.alertaMensager("Erro ao cadastrar item no servidor.", "Erro", "error");
            });
        }
    },

    resetModal() {
        this.item = { idItem: null, nome: '', descricao: '', status: true, problema: { idProblema: null }, tiposSelecionados: ['ANDAR', 'SALA'] };
    },

    onFiltered(filteredItems) {
        this.rows = filteredItems.length;
        this.currentPage = 1;
    },

    listarItens(){
        this.$loading(true);
        ItemService.listarTodos().then(res => {
            this.itens = res.data;
            this.rows = this.itens.length;
        }).finally(() => {
            this.$loading(false);
        });
    },

    listarProblemas(){
        this.$http.get("/problema").then(res => {
            this.problemas = res.data;
        });
    },

    visualizar(itemObj){
        let fetchedItem = JSON.parse(JSON.stringify(itemObj)); 
        if (!fetchedItem.problema) {
            fetchedItem.problema = { idProblema: null };
        }
        fetchedItem.tiposSelecionados = ['ANDAR', 'SALA'];
        this.item = fetchedItem;
        
        this.$http.get(`/item-configuracao/${fetchedItem.idItem}`).then(res => {
            if (res.status === 200 && Array.isArray(res.data)) {
                this.item.tiposSelecionados = res.data;
            }
            this.$refs.modal.show();
        }).catch(() => {
            this.$refs.modal.show();
        });
    },

    alterarStatus(item){
        const novoStatus = !item.status;
        ItemService.alterarStatus(item.idItem, novoStatus).then(() => {
            item.status = novoStatus;
            this.alertaMensager("Status atualizado com sucesso!", "", "success");
        }).catch(() => {
            // Reverte o valor do toggle em caso de erro
            item.status = !novoStatus;
            this.alertaMensager("Erro ao alterar status.", "Erro", "error");
        });
    },

    // confirmarDelecao(item) {
    //     this.$bvModal.msgBoxConfirm(`Tem certeza que deseja excluir o item '${item.nome}'?`, {
    //       title: 'Confirmar Exclusão',
    //       size: 'sm',
    //       buttonSize: 'sm',
    //       okVariant: 'danger',
    //       okTitle: 'Sim, excluir',
    //       cancelTitle: 'Cancelar',
    //       footerClass: 'p-2',
    //       hideHeaderClose: false,
    //       centered: true
    //     })
    //       .then(value => {
    //         if (value) {
    //             ItemService.deletar(item.idItem).then((res) => {
    //                 if (res.status === 203) {
    //                     this.alertaMensager(res.data, "Erro", "error");
    //                 } else {
    //                     this.alertaMensager("Item excluído com sucesso!", "", "success");
    //                     this.listarItens();
    //                 }
    //             }).catch(() => {
    //                 this.alertaMensager("Erro ao excluir item.", "Erro", "error");
    //             });
    //         }
    //       })
    // }
  }
}
</script>

<style scoped>
.v-button {
  color: white;
  cursor: pointer;
}
</style>
